import React, { useState } from "react";
import "./ClientConsents.css";

const ClientConsents = () => {
  const [status, setStatus] = useState("Not Requested");
  const [formType, setFormType] = useState("");
  const [emailSignature, setEmailSignature] = useState("Default");

  return (
    <div className="client-consents-container">
      <div className="consents-header-box">
        <h2 className="consents-title">Client Consents</h2>
      </div>

      <div className="consents-form-box">
        <div className="consents-form-row">
          <div className="form-group">
            <label>Status *</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option>Not Requested</option>
              <option>Requested</option>
              <option>Completed</option>
            </select>
          </div>

          <div className="form-group">
            <label>Form Type *</label>
            <select
              value={formType}
              onChange={(e) => setFormType(e.target.value)}
            >
              <option>Form Type</option>
            </select>
          </div>

          <div className="form-group">
            <label>Email Signature</label>
            <select
              value={emailSignature}
              onChange={(e) => setEmailSignature(e.target.value)}
            >
              <option>Default</option>
            </select>
          </div>
        </div>

        <div className="consents-button-row">
          <button className="search-btn">Search</button>
          <button className="csv-btn">Export to CSV</button>
        </div>
      </div>

      <table className="consents-table">
        <thead>
          <tr>
            <th>
              <input type="checkbox" />
            </th>
            <th>
              Type <span className="sort-icon">⇅</span>
            </th>
            <th>
              Patient Name <span className="sort-icon">⇅</span>
            </th>
            <th>
              Date Requested <span className="sort-icon">⇅</span>
            </th>
            <th>
              Date Completed <span className="sort-icon">⇅</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="empty-row">
            <td colSpan="5" className="empty-text">
              There is no data to display
            </td>
          </tr>
        </tbody>
      </table>

      <div className="consents-footer">
        <select className="footer-dropdown">
          <option>10</option>
          <option>20</option>
          <option>50</option>
        </select>
        <button className="signature-btn">Request e-signature</button>
      </div>
    </div>
  );
};

export default ClientConsents;
